import { useState } from 'react';

// Export für die Betriebsprüfung (Admin, Gesetzes-Prüfung C6): Belege des Mandanten und die eigenen Rechnungen an ihn
// für einen Zeitraum als ZIP-Datei, mit Listen als CSV und Excel und einer Beschreibung der Spalten.
export function PruefungExport({ clientId }: { clientId: string }) {
  const last = new Date().getFullYear() - 1;
  const [von, setVon] = useState(`${last}-01`);
  const [bis, setBis] = useState(`${last}-12`);
  const ok = /^\d{4}-\d{2}$/.test(von) && /^\d{4}-\d{2}$/.test(bis) && von <= bis;
  const url = `/api/kanzlei/clients/${clientId}/export?von=${von}&bis=${bis}`;
  return (
    <section className="card" aria-labelledby="pe-h">
      <div className="ch">
        <h3 id="pe-h">Export für die Betriebsprüfung</h3>
      </div>
      <p className="note">
        Belege des Mandanten und Ihre Rechnungen an ihn als ZIP-Datei, dazu die Listen als Excel und CSV. Für die Betriebsprüfung
        oder wenn das Finanzamt Daten anfordert.
      </p>
      <div className="form">
        <div className="row">
          <label>
            Von
            <input type="month" value={von} max={bis} onChange={(e) => setVon(e.target.value)} />
          </label>
          <label>
            Bis
            <input type="month" value={bis} min={von} onChange={(e) => setBis(e.target.value)} />
          </label>
        </div>
        {ok ? (
          <a className="btn sm dark" href={url} download>
            ZIP herunterladen
          </a>
        ) : (
          <p className="note">Bitte den Zeitraum prüfen: Der Beginn liegt nach dem Ende.</p>
        )}
      </div>
    </section>
  );
}
